'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-title-utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../sfdc-legend-utils/index.js');

var _index4 = _interopRequireDefault(_index3);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var runtime = _sdk2.default.runtime;
var ThemeFactory = _sdk2.default.ThemeFactory;
var ref = _sdk2.default.utils;
var configUtils = ref.configUtils;

var AbstractPlot = function AbstractPlot(config, rows, rowsMetadata, props, delegate) {
  this.config = config;

  if (config.theme && !config.theme._theme) {
    config.theme = ThemeFactory.getInstance().fetchByConfig(config.theme);
  }

  this.rows = rows;
  this.rowsMetadata = rowsMetadata;
  this.delegate = delegate;
  this._settledLayouts = false;
  configUtils.sanitizeChartTitleConfig(config.title);
};

AbstractPlot.prototype.sanitizeConfig = function sanitizeConfig() {
  var config = this.config;

  if (config.trellis && config.trellis.column.length < 1) {
    delete config.trellis;
  }
};

AbstractPlot.prototype.isTrellis = function isTrellis() {
  return configUtils.isTrellis(this.config);
};

AbstractPlot.prototype.updateContext = function updateContext(context) {
  return;
};

AbstractPlot.prototype.onExportToTrellisCell = function onExportToTrellisCell() {};

AbstractPlot.prototype.onAfterTrellisPlot = function onAfterTrellisPlot() {};

AbstractPlot.prototype.onBeforeTrellisRemove = function onBeforeTrellisRemove() {};

AbstractPlot.prototype.remove = function remove(context, nextChart) {};

AbstractPlot.prototype.getDataFormatter = function getDataFormatter() {};

AbstractPlot.prototype.getLegend = function getLegend() {};
/**
	 * Initialize a scene for chart
	 *
	 * Later the scene will be passed to plot and postPlot, scene tree will be enriched
	 * with layers and shapes according to data rows.
	 *
	 * @return {Scene}
	 */


AbstractPlot.prototype.initScene = function initScene(config, rows) {};
/**
	 * Plot shapes on scene
	 */


AbstractPlot.prototype.plot = function plot(config, rows, scene) {};

AbstractPlot.prototype.hasSettledLayouts = function hasSettledLayouts() {
  return !!this._settledLayouts;
};

AbstractPlot.prototype.resetLayouts = function resetLayouts() {
  this._settledLayouts = false;
};
/**
	 * Chart could be updating layouts during plot, call settleLayout
	 */


AbstractPlot.prototype.settleLayouts = function settleLayouts() {
  this._settledLayouts = true;
};
/**
	 * Invoked after plot, to give chart a chance to break down plotting process into
	 * two phases, 1st plot, 2nd postPlot.
	 *
	 * It is necessary in trellis use case, where trellis chart will call plot on all
	 * cell charts, after that, call postPlot on all cell charts, so in postPlot, we
	 * can assume all cell charts has finished phase 1 plot, so we can settle layouts
	 * based on the information accumulated
	 */


AbstractPlot.prototype.postPlot = function postPlot(config, rows, scene) {};
/**
	 * Default render flow
	 */


AbstractPlot.prototype.render = function render(context) {
  var legend;
  var config = this.config;
  var rows = this.rows;
  var theme = config.theme;
  var padding = config.padding;
  var title = config.title; // Copy original padding

  var scenePadding = _core2.default.clone(padding);

  var titleSize;
  var legendConfig; // Set titleSize now in case the chart will be empty

  if (title) {
    titleSize = _index2.default.getTitleSize(title);
    config.padding = _index2.default.adjustChartPaddingForTitle(config.padding, titleSize);
  } // sanitize legend
  // - modify config.size, config.padding


  var legendWidget = config.legend && this.getLegend();

  if (legendWidget) {
    // calculate legend position and size to pass to the main chart
    legendConfig = _index4.default.santizeLegendChartConfig(config, legendWidget);

    if (!legendConfig) {
      // do not draw legend
      legendWidget = undefined;
    }
  } // draw chart


  var scene = this.initScene(config, rows, context);
  this.updateContext(context);
  this.plot(config, rows, scene, context);
  this.settleLayouts();
  this.postPlot(config, rows, scene, context); // draw legend

  if (legendWidget) {
    runtime.getPerf().mark("legend"); // get legend again, we construct legend based on chart layouts, they
    // might have changed during plot

    legendWidget = this.getLegend();
    legendWidget.extendConfig(legendConfig);
    legend = legendWidget.render();
    legend.getCells().forEach(function (cell) {
      cell.getLayers().forEach(function (layer) {
        layer.postProcess();
      });
    });
    runtime.getPerf().endMark("legend");
  } // draw title


  if (title && titleSize > 0) {
    var sceneSize = scene.get("size");
    scene.prepend(_index2.default.getTitleCell(config, titleSize, title, theme, sceneSize, scenePadding));
  } // let's post process the layers


  scene.getCells().forEach(function (cell) {
    cell.getLayers().forEach(function (layer) {
      layer.postProcess();
    });
  }); // attach legend to main scene

  scene.legend = legend;
  scene.set({
    config: config,
    rowsMetadata: this.rowsMetadata,
    background: theme.getBackgroundColor(),
    dataFormatter: this.getDataFormatter()
  });
  return scene;
};

exports.default = AbstractPlot;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;